import { Female, LangBulkAction1, LangBulkAction2, LangBulkAction3, LangBulkAction4, LangBulkAction5, LangBulkAction6, LangBulkAction7, LangBulkAction8, Male } from './languange'

export const bulkActions = [
  { name: LangBulkAction1, val: 'annual_leave_set' },
  { name: LangBulkAction3, val: 'annual_leave_add' },
  { name: LangBulkAction2, val: 'annual_leave_subtract' },
  { name: LangBulkAction7, val: 'leave_in_hour_request_set' },
  { name: LangBulkAction8, val: 'auto_clock_out_set' },
  { name: LangBulkAction4, val: 'change_group' },
  { name: LangBulkAction6, val: 'send_verification_email' },
  { name: LangBulkAction5, val: 'mass_delete' }
]

export const leaveInHourRequestSetAction = {
  can_replace: 1,
  is_apply_deduction: 1,
  apply_late_penalty: 0
}

export const massDeleteAction = {
  deleted_reason: ''
}

export const changeGroupAction = {
  change_group_value: ''
}

export const setAnunalLeaveAction = {
  set_value: '',
  set_expired_at: ''
}

export const addAnnualLeaveAction = {
  add_value: '',
  add_expired_month: ''
}

export const substractAnnualLeaveAction = {
  subtract_value: '',
  subtract_expired_month: ''
}

export const autoClockOutSetAction = {
  auto_clock_out_enable: 0,
  auto_clock_out_after_minute: '',
  auto_clock_out_as_scheduled: 0
}

export const genderType = {
  male: Male,
  female: Female
}
